// extracted by mini-css-extract-plugin
export var container = "styles-module--container--f3tCU";
export var label = "styles-module--label--vIU9Y";
export var labelText = "styles-module--labelText--akns9";